<h2 mat-dialog-title>{{ 'CAMPAIGN_DETAILS.ACTIONS.COPY_DIALOG_SUCCESS.SUCCESS_TITLE' | translate }}</h2>
<mat-dialog-content [title]="">
  <p>{{ 'CAMPAIGN_DETAILS.ACTIONS.COPY_DIALOG_SUCCESS.OPEN_COPIED_CAMPAIGN' | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="goToNewCampaign()">
    <span>{{ 'CAMPAIGN_DETAILS.ACTIONS.COPY_DIALOG_SUCCESS.OPEN_BUTTON' | translate }}</span>
  </button>
  <button mat-button color="primary" (click)="closeDialog()">
    <span>{{ 'CAMPAIGN_DETAILS.ACTIONS.COPY_DIALOG_SUCCESS.CLOSE' | translate }}</span>
  </button>
</mat-dialog-actions>
